<uni-icon [name]="iconName" [isAction]="true"></uni-icon>
